import { apiClient } from './axiosInstance';

export const fetchClientsFilterList = async () => {
  return await apiClient.get(`/clients/base/clients`);
};
